import { useTranslation } from "react-i18next";
import ProgressionCheckbox from "./ProgressionCheckbox";

const LoadToggle = ({ handleLoadSwitch, percent, units }) => {
  return (
    <div className="load-toggle">
      <button
        data-button-type={percent ? "outline" : "text-white"}
        onClick={(e) => {
          e.preventDefault();
          if (!percent) handleLoadSwitch(e);
        }}
      >
        %
      </button>
      <button
        data-button-type={!percent ? "outline" : "text-white"}
        onClick={(e) => {
          e.preventDefault();
          if (percent) handleLoadSwitch(e);
        }}
      >
        {units}
      </button>
    </div>
  );
};

const LoadProgression = ({
  handleCheck,
  handleLoadSwitch,
  loadSwitch,
  checked,
}) => {
  const { t } = useTranslation("coaching-portal");
  const { percent, units } = loadSwitch;

  return (
    <div className="load-progression">
      <ProgressionCheckbox
        checked={checked}
        name="loadProgression"
        onChange={handleCheck}
      >
        {t("loadProgression.addProgressionsToLoad")}
      </ProgressionCheckbox>
      <LoadToggle
        handleLoadSwitch={handleLoadSwitch}
        percent={percent}
        units={units}
      />
    </div>
  );
};

export default LoadProgression;
